module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ContentsPage"
  }, [_c('h1', [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('ol', [_c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Chapter1"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The once and future King")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "Subtitle"
  }, [_vm._v("Who rules the world?")])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Psalm 2")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("Naked ape or divine image?")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "Subtitle"
  }, [_vm._v("Who am I?")])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Psalm 8 and Hebrews 2:5–18")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("God’s marriage")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "Subtitle"
  }, [_vm._v("Is a perfect relationship possible?")])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Ezekiel 16")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("Wealth and possessions")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "Subtitle"
  }, [_vm._v("Your money or your life?")])]), _vm._v(" "), _c('p', [_vm._v("Bible study: 1 Timothy 6:6–19")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The Holy Spirit")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "Subtitle"
  }, [_vm._v("What is his work?")])]), _vm._v(" "), _c('p', [_vm._v("Bible study: The Spirit in John’s Gospel")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("God and the nations")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "Subtitle"
  }, [_vm._v("What is God’s plan for the world?")])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Isaiah 66:18–24")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/FurtherReading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 63
// module chunks = 0